import { ValidatorFn, AbstractControl } from '@angular/forms';
export function EbAccountValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    const value = control.value;
    
    if (!value) return null;
    return null;
  };
}
